/**
 * @generated SignedSource<<be6515ebe11df8688934488959a07356>>
 * @relayHash afa8664360527d902e240ba8f2439caa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceUpdateReviewerDecisionInput = {
  comment?: string | null | undefined;
  decisionStatus: ConfluenceReviewerDecisionState;
  reviewerId: AGG$Long;
};
export type ApprovalsContextUpdateReviewerDecisionMutation$variables = {
  cloudId: string;
  confluenceUpdateReviewerDecisionInput: ConfluenceUpdateReviewerDecisionInput;
};
export type ApprovalsContextUpdateReviewerDecisionMutation$data = {
  readonly confluence_updateReviewerDecision: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type ApprovalsContextUpdateReviewerDecisionMutation = {
  response: ApprovalsContextUpdateReviewerDecisionMutation$data;
  variables: ApprovalsContextUpdateReviewerDecisionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "confluenceUpdateReviewerDecisionInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "confluenceUpdateReviewerDecisionInput",
    "variableName": "confluenceUpdateReviewerDecisionInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextUpdateReviewerDecisionMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
        "kind": "LinkedField",
        "name": "confluence_updateReviewerDecision",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextUpdateReviewerDecisionMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
        "kind": "LinkedField",
        "name": "confluence_updateReviewerDecision",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "afa8664360527d902e240ba8f2439caa",
    "id": "3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde",
    "metadata": {},
    "name": "ApprovalsContextUpdateReviewerDecisionMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsContextUpdateReviewerDecisionMutation($cloudId:ID!,$confluenceUpdateReviewerDecisionInput:ConfluenceUpdateReviewerDecisionInput!){confluence_updateReviewerDecision(cloudId:$cloudId,confluenceUpdateReviewerDecisionInput:$confluenceUpdateReviewerDecisionInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "60408e64e95523cddd0fb83ab25da2c7";

export default node;
